<template>
  <div class="home section">
    <header class="field">
      <h1 class="title is-1">Welcome</h1>
    </header>
    <section>
      <div class="content">
        <p>
          The firmware on this device uses a multitude of applications and libraries that
          are free and open-source software. In an effort of full transparency we disclose
          the list of projects and components that are part of this release
          including their respective licenses.
        </p>
        <p>
          The firmware is based on the <a href="https://www.debian.org/">Debian GNU/Linux</a>
          distribution. We would would like to thank the Debian project and its numerous
          maintainers and contributors for their continuing excellent work and dedication
          to the spirit of free software.
        </p>

        <p>
          Please see the navigation on the left-hand side for detailed licensing information
          on specific packages. In case you prefer an offline version there is also a
          <a href="./data/license-data.pdf" download>PDF file</a>, that you can
          download for your convenience.
        </p>

        <p>
          If you have reason to believe that this firmware contains software, that:
        </p>

        <ul>
          <li>is not listed or disclosed on this page</li>
          <li>has not been attributed in a way, that fulfills the requirements of the license</li>
          <li>or should not have been included in the first place</li>
        </ul>

        <p>
          please do not hesitate to contact us either by email or by post.
          You will find the contact details on the <a href="../doc/api">API Documentation Page</a>.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'home'
  }
</script>
